/**
 * Kotyal Traders - Agricultural Trading Platform
 * 
 * Designed & Developed by: Akshay Bellagi
 * Phone: +91 7676831143
 * 
 * © 2025 Kotyal Traders. All rights reserved.
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/public/Home';
import About from './pages/public/About';
import Services from './pages/public/Services';
import Products from './pages/public/Products';
import Contact from './pages/public/Contact';
import Login from './pages/auth/Login';
import Business from './pages/Business';
import './App.css';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  return isLoggedIn ? children : <Navigate to="/login" />;
};

// Layout wrapper to conditionally show Navbar and Footer
const Layout = ({ children }) => {
  const location = useLocation();
  const hideNavAndFooter = location.pathname === '/business';

  return (
    <>
      {!hideNavAndFooter && <Navbar />}
      {children}
      {!hideNavAndFooter && <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <ScrollToTop />
        <div className="App">
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/products" element={<Products />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route 
                path="/business" 
                element={
                  <ProtectedRoute>
                    <Business />
                  </ProtectedRoute>
                } 
              />

            </Routes>
          </Layout>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App; 